exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.cube-tab-panel {\n  width: 100%;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 0 auto;\n          flex: 1 0 auto;\n}", "", {"version":3,"sources":["/Users/Mac/Documents/new_rzl_workspace/hhr_callfee/node_modules/cube-ui/src/components/tab-panels/tab-panel.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;UACf,eAAe;CACxB","file":"tab-panel.vue","sourcesContent":["\n.cube-tab-panel {\n  width: 100%;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 0 auto;\n          flex: 1 0 auto;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08f154b4","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader?{"resolve url":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/cube-ui/src/components/tab-panels/tab-panel.vue
// module id = +lh2
// module chunks = 27